<template>
    <ul :class="['parking-sly', modify]">
        <li v-for="item in listPretty.slice().reverse()" :key="item.id"
            :class="['parking-sly__item', {'is-disabled': item.disabled},
            {'is-active': Number(item.id) === Number(activeId)}]"
            @click="!item.disabled && $emit('click', item)">
            <span class="parking-sly__count">
                {{ item.count }}<span v-if="!item.count">0</span> {{ item.countWord }}
            </span>
            <span class="parking-sly__number">{{ item.number }}</span>
        </li>
    </ul>
</template>

<script>
export default {
    props: ['list', 'activeId', 'modify'],

    computed: {
        listPretty() {
            return this.list ?
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.list.sort((a, b) => {
                    return Number(a.number) - Number(b.number);
                }) :
                [];
        }
    }
};
</script>
